module.exports = __webpack_public_path__ + "img/event-sort.c2f8b396.svg";